/**
 * invoices-api
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface InvoiceStatusDto { 
    name: InvoiceStatusDto.NameEnum;
    reason?: InvoiceStatusDto.ReasonEnum;
    dateTime: string;
}
export namespace InvoiceStatusDto {
    export const NameEnum = {
        Draft: 'DRAFT',
        Due: 'DUE',
        Paid: 'PAID',
        PaymentFailed: 'PAYMENT_FAILED',
        Uncollectible: 'UNCOLLECTIBLE'
    } as const;
    export type NameEnum = typeof NameEnum[keyof typeof NameEnum];
    export const ReasonEnum = {
        InvoiceCreated: 'INVOICE_CREATED',
        InvoiceClosed: 'INVOICE_CLOSED',
        InvoicePaid: 'INVOICE_PAID',
        InvoicePaymentFailed: 'INVOICE_PAYMENT_FAILED',
        InvoicePaymentUncollectible: 'INVOICE_PAYMENT_UNCOLLECTIBLE',
        InvoiceRetryPayment: 'INVOICE_RETRY_PAYMENT'
    } as const;
    export type ReasonEnum = typeof ReasonEnum[keyof typeof ReasonEnum];
}


